import React, { Component } from 'react';
import { Router, Route, withRouter } from 'react-router-dom';
import classnames from 'classnames';

import Sidebar from '../Sidebar/SidebarContainer';
import PageRoutes from '../../routes';
import DisconnectNotificationBar from '../DisconnectNotificationBar/DisconnectNotificationBarContainer';
import * as Sentry from '@sentry/react';
import { initializeSentry, isSentryEnabled } from '../../helpers/SentryUtils';

class Application extends Component {
  componentDidUpdate(prevProps) {
    const { router, toggleMobileMenu } = this.props;
    if (router.location.pathname !== prevProps.location.pathname) {
      toggleMobileMenu(false);
    }
  }

  toggleMenuVisibility = () => {
    const { mobileMenuOpened, toggleMobileMenu } = this.props;
    toggleMobileMenu(!mobileMenuOpened);
  };

  render() {
    const { history, mobileMenuOpened } = this.props;
    return (
      <Router history={history}>
        <Route render={({ location }) => ( // always matches. location is used for CSSTransition
          <div className={classnames({
            'page-item': true,
            'opened': mobileMenuOpened,
          })}>
            <DisconnectNotificationBar />
            <Sidebar qaId="sidebar" location={location} history={history}/>
            {mobileMenuOpened && <div className="mobile-overlay" onClick={this.toggleMenuVisibility} />}
            <Route component={PageRoutes} />
          </div>
        )} />
      </Router>
    );
  }
}

initializeSentry();

let router = withRouter(Application);

if (isSentryEnabled()) {
  // wraps app in an "error boundary" such that any exceptions that bubble to here are pushed to Sentry
  Sentry.withErrorBoundary(Application, {
    fallback: <p>an error has occurred</p>,
  });
  router = Sentry.withProfiler(router);
}

export default router;
